import { render, staticRenderFns } from "./PhotoView.vue?vue&type=template&id=4245b1bd&scoped=true&"
import script from "./PhotoView.vue?vue&type=script&lang=js&"
export * from "./PhotoView.vue?vue&type=script&lang=js&"
import style0 from "./PhotoView.vue?vue&type=style&index=0&id=4245b1bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4245b1bd",
  null
  
)

export default component.exports